import { render } from "./formatted-request.vue?vue&type=template&id=4f9afb6e"
import script from "./formatted-request.vue?vue&type=script&lang=js"
export * from "./formatted-request.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__